<template>
  <div class="mx-auto pa-5">
    <h1 class="text-white">
      2026年2月19日発売！！
    </h1>
    <div class="text-center my-10">
      <v-btn
        variant="outlined"
        href="https://mario484.com"
        color="primary"
        target="_blank"
        align="center"
        width="100%"
        max-width="640"
        height="180"
        class="px-10"
      >
        <p class="text-h5">2026年2月20日（金）<br/> famicom shop mario 新橋店<br/>
原作 飯島多紀哉（飯島健男）氏 サイン会 開催</p>
      </v-btn>
    </div>
  </div>

  <!-- <SubTitle :TitleName="'PV'" />
  <Movie /> -->
</template>

<script>
  //import SS from "./ScreenShot.vue";
  //import SubTitle from "./SubTitle.vue";
  //import Movie from "./YouTube.vue";

  // export default {
  //   name: "App",
  //   components: {
  // SS,
  //SubTitle,
  // Movie,
  //   },
  // };
</script>
